import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, HeartIcon, ChevronRightIcon, ChevronLeftIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
// This component displays relevant listings in the dashboard header
// Brands will see organizers, and organizers will see brands
export function DashboardListingsBar() {
  const {
    currentUser
  } = useAuth();
  const [listings, setListings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  useEffect(() => {
    const fetchListings = async () => {
      setLoading(true);
      try {
        // Fetch listings based on user type
        if (currentUser?.type === 'brand') {
          // Brands see organizers
          const organizers = JSON.parse(localStorage.getItem('organizers') || '[]');
          setListings(organizers);
        } else if (currentUser?.type === 'organizer') {
          // Organizers see brands
          const brands = JSON.parse(localStorage.getItem('brands') || '[]');
          setListings(brands);
        }
      } catch (error) {
        console.error('Error fetching listings:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchListings();
  }, [currentUser]);
  // Skip rendering if not logged in or no listings
  if (!currentUser || listings.length === 0) {
    return null;
  }
  const totalPages = Math.ceil(listings.length / itemsPerPage);
  const displayListings = listings.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  if (loading) {
    return <div className="flex justify-center items-center h-12" data-id="element-390">
        <div className="animate-spin h-5 w-5 border-2 border-indigo-500 rounded-full border-t-transparent" data-id="element-391"></div>
      </div>;
  }
  return <div className="flex items-center justify-between" data-id="element-392">
      <div className="flex-shrink-0 mr-4" data-id="element-393">
        <button onClick={prevPage} disabled={currentPage === 0} className={`p-1 rounded-full ${currentPage === 0 ? 'text-gray-300' : 'text-gray-500 hover:bg-gray-100'}`} data-id="element-394">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-395" />
        </button>
      </div>
      <div className="flex-1 overflow-hidden" data-id="element-396">
        <div className="flex space-x-4" data-id="element-397">
          {displayListings.map(item => {
          const isBrand = 'companyName' in item;
          const name = isBrand ? item.companyName : item.organizerName;
          const description = isBrand ? (item.productDescription || '').substring(0, 60) + '...' : (item.elevatorPitch || '').substring(0, 60) + '...';
          return <div key={item.id} className="flex-shrink-0 w-64 border rounded-lg p-3 bg-white shadow-sm" data-id="element-398">
                <div className="flex justify-between items-start mb-2" data-id="element-399">
                  <h3 className="font-medium text-gray-900 truncate" data-id="element-400">{name}</h3>
                  <div className="flex space-x-1" data-id="element-401">
                    <button className="p-1 rounded-full text-gray-400 hover:text-yellow-500" title="Save for later" data-id="element-402">
                      <StarIcon className="h-4 w-4" data-id="element-403" />
                    </button>
                    <button className="p-1 rounded-full text-gray-400 hover:text-red-500" title="Show interest" data-id="element-404">
                      <HeartIcon className="h-4 w-4" data-id="element-405" />
                    </button>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mb-3 line-clamp-2" data-id="element-406">
                  {description}
                </p>
                <div className="text-right" data-id="element-407">
                  <Link to={isBrand ? `/brands/${item.id}` : `/organizers/${item.id}`} className="text-xs text-indigo-600 hover:text-indigo-800 font-medium inline-flex items-center" data-id="element-408">
                    View details
                    <ChevronRightIcon className="h-3 w-3 ml-1" data-id="element-409" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
      <div className="flex-shrink-0 ml-4" data-id="element-410">
        <button onClick={nextPage} disabled={currentPage >= totalPages - 1} className={`p-1 rounded-full ${currentPage >= totalPages - 1 ? 'text-gray-300' : 'text-gray-500 hover:bg-gray-100'}`} data-id="element-411">
          <ChevronRightIcon className="h-5 w-5" data-id="element-412" />
        </button>
      </div>
      <div className="ml-4 border-l pl-4" data-id="element-413">
        <Link to={currentUser?.type === 'brand' ? '/organizers' : '/brands'} className="text-sm text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-414">
          View all
        </Link>
      </div>
    </div>;
}